import script from "./StoreSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./StoreSettings.vue?vue&type=script&setup=true&lang=js"

import "./StoreSettings.vue?vue&type=style&index=0&id=2dfa0c19&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dfa0c19"]])

export default __exports__